export function fullNameMinLength() {
  return 2;
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/validation/fullName.js